import style from "./style.module.scss";

/**
 * Nuvem compacta de itens de um pacote (eventos, assessoria, fundo de reserva) — cada um
 * como um chip "rótulo + valor", lado a lado, quebrando linha conforme o espaço. Substitui a
 * antiga listagem em BlockItem (uma linha inteira por item, precisando abrir o accordion pra ver).
 */
export default function PackageItemsCloud(props) {
  const { items = [], fullWidth } = props;

  return (
    <div className={style.cloud} data-full-width={!!fullWidth}>
      {items.map((__item, __item_i) => (
        <div className={style.chip} data-tone={__item.tone || ""} key={__item.key || __item_i}>
          <div className={style.row}>
            <span className={style.label}>{__item.label}</span>
            <span className={style.value}>{__item.value}</span>
          </div>
          {!!__item.note && <span className={style.note}>{__item.note}</span>}
        </div>
      ))}
    </div>
  );
}
